import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { Link as RouterLink, useRouteMatch } from 'react-router-dom';
import { Box, Paper, Typography, Link } from '@mui/material';

import { DoubleField } from '../../../support/components/DoubleField';
import { formatDate } from '../../../../utils/formatDate';
import { timeIsOver } from '../../../../utils/timeIsOver';
import { getColorStatusApplication } from '../../../../utils/getColorStatusApplication';
import { getRouteWithParam, ROUTES } from '../../../../constants/routes';
import { useSearchCustomerBy } from '../../../../hooks/useSearchCustomerBy';
import { CustomButton } from '../../../../components/CustomButton';
import { APPLICATION_STATUS, DISABLED_CONTROL_TOOLTIP, PERMISSIONS } from '../../../../constants/variables';
import { postHandlerApplication } from '../../../../store/support/actions';
import { visibleBySectionPermission } from '../../../../utils/visibleBySectionPermission';

export const Application = ({
  numberApplication,
  nameCreator,
  dateCreate,
  SLA,
  bonusesNumber,
  status,
  id,
  handlerStatus = false,
  userPermissions = {},
  disabled,
  ...props
}) => {
  const [state, setState] = useState();
  const dispatch = useDispatch();
  const location = useRouteMatch();
  const { createPath } = useSearchCustomerBy();

  const submitApplication = useCallback((status) => {
    dispatch(
      postHandlerApplication(id, {
        request_status: status,
        amount: null
      })
    );
    setTimeout(() => setState(), 1000);
  }, // eslint-disable-next-line
    []);

  const checkLocation = location.path.includes('application')
    ? getRouteWithParam(ROUTES.APPLICATION_DETAILED, ':appID', id)
    : getRouteWithParam(createPath(ROUTES.SUPPORT_DETAIL_APPLICATION), ':appID', id);

  const isDisabledUpdateBonusRequestsPermission = !visibleBySectionPermission(userPermissions, PERMISSIONS.SUPPORT.UpdateSupportBonusRequests.value);

  return (
    <Link component={RouterLink} underline="none" color="inherit" to={disabled ? null : checkLocation}>
      <Paper sx={{
        minHeight: '140px',
        padding: '24px',
        marginTop: '16px',
        ...visibleBySectionPermission(userPermissions, PERMISSIONS.SUPPORT.ListSupportBonusRequests.value)
      }}
         {...props}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '16px'
          }}>
          <Typography
            variant="h5"
            sx={{
              fontSize: '26px',
              fontWeight: 500,
              color: timeIsOver(SLA) && 'error.main'
            }}>
            {numberApplication}
          </Typography>
          <Typography sx={{ color: getColorStatusApplication(status) }}>{status}</Typography>
        </Box>

        <Box display="grid" gridTemplateColumns="repeat(5, 1fr)">
          <DoubleField title="Заявку создал" description={nameCreator} />
          <DoubleField title="Дата создания" description={formatDate(dateCreate)} />
          <DoubleField title="SLA" description={formatDate(SLA)} />
          <DoubleField title="Бонусный счет" description={bonusesNumber} />
          {handlerStatus && APPLICATION_STATUS.new.label === status && (
            <Box display="flex" justifyContent="flex-end">
              <CustomButton
                disabled={state === id || isDisabledUpdateBonusRequestsPermission}
                onClick={(e) => {
                  e.preventDefault();
                  setState(id);
                  submitApplication(APPLICATION_STATUS.in_processing.status);
                }}
                variant="outlined"
                tooltip={isDisabledUpdateBonusRequestsPermission ? DISABLED_CONTROL_TOOLTIP : null}
                data-testid="ToWorkButton"
              >
                В работу
              </CustomButton>
            </Box>
          )}
        </Box>
      </Paper>
    </Link>
  );
};

Application.propTypes = {
  numberApplication: PropTypes.string,
  nameCreator: PropTypes.string,
  dateCreate: PropTypes.string,
  SLA: PropTypes.string,
  bonusesNumber: PropTypes.string,
  status: PropTypes.string,
  id: PropTypes.number,
  handlerStatus: PropTypes.bool,
  userPermissions: PropTypes.object,
  disabled: PropTypes.bool,
};
